module.exports = __webpack_public_path__ + "img/w.90552924.jpg";